import PATH from '../paths';

const name = 'Invest Life';
const key = 'investlife';
const imgUrl = `${ PATH.CDN }/whitelabels/${ key }`;
const images = {
  favicon: `${ imgUrl }/favicon.png`,
  logo: `${ imgUrl }/logo.svg`,
  logoPDF: `${ imgUrl }/logo-pdf.png`,
  logoSidebar: `${ imgUrl }/logo-sidebar.png`,
  opengraph: false,
  backgrounds: [
    `${ imgUrl }/background.jpg`
  ],
};

export default {
  name,
  key,
  images,
  stylesheet: `
    /* COLOR VARIABLES +++++++++++++++++++++++++++++++++++++++++++++++++++++  */


    --color-il-blue:                  #005198;
    --color-il-grey:                  #58595b;

    --color-primary:                  var(--color-il-blue);
    --color-secondary:                var(--color-il-grey);
    --color-accent:                   var(--color-white);

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* TYPOGRAPHY ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    --color-link:                     var(--color-il-blue);
    --color-link-hover:               var(--color-darker);

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */
   
    /* LAYOUTS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* ANONYMOUS LAYOUT */

    --anonymous-logo-bg:              transparent;
    --anonymous-copy-bg:              var(--color-il-blue);
    --anonymous-heading-color:        var(--color-white);
    --anonymous-subheading-color:     var(--color-white);
    --anonymous-text-color            var(--color-white);
    --anonymous-logo-height:          50px;
    --anonymous-bg:                   url(${ images.backgrounds[0] });
    --anonymous-bg-size:              cover;

    /* END */

    /* SIDEBAR */

    --sidebar-bg-color: var(--color-il-blue);
    --sidebar-logo-bg-color: var(--color-white);
    --sidebar-logo-height: 45px;
    --sidebar-label-color: rgba(var(--color-white-rgb), 0.7);
    --sidebar-border-color: var(--color-white);

    --sidebar-button-color: var(--color-accent);
    --sidebar-button-color-active: var(--color-il-blue);
    --sidebar-button-color-hover: var(--color-il-blue);
    --sidebar-button-bg-color: var(--color-il-blue);
    --sidebar-button-bg-color-active: var(--color-white);
    --sidebar-button-bg-color-hover: var(--color-white);
    --sidebar-button-border-color: var(--color-white);
    --sidebar-button-border-color-active: var(--color-white);
    --sidebar-button-border-color-hover: var(--color-white);

    /* END */

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* BUTTONS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* PRIMARY BUTTON */

    --btn-primary--bg:                var(--color-il-blue);
    --btn-primary--border:            var(--color-il-blue);
    --btn-primary--color:             var(--color-white);
    --btn-primary--colorH:            var(--color-white);
    --btn-primary--bgH:               var(--color-il-grey);
    --btn-primary--borderH:           var(--color-il-grey);

    /* END */

    /* SECONDARY BUTTON */

    --btn-secondary--bg:              transparent;
    --btn-secondary--border:          var(--color-il-blue);
    --btn-secondary--color:           var(--color-il-blue);
    --btn-secondary--bgH:             transparent;
    --btn-secondary--borderH:         var(--color-dark);
    --btn-secondary--colorH:          var(--color-dark);

    /* END */

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */
  `,
};
